import { useSWR } from '~/hooks/useSWR';

import { getCompanyForms } from '.';

export const useGetCompanyForms = () => {
  const { data, ...rest } = useSWR(['companyForms'], () => getCompanyForms());

  return {
    data: data ?? [],
    ...rest,
  };
};
